(function () {
  const ready = (fn) => {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  };

  ready(() => {
    document.querySelectorAll("[data-mcc-menu-toggle]").forEach((button) => {
      button.addEventListener("click", () => {
        const header = button.closest(".mcc-2026-header");
        const expanded = header?.classList.toggle("is-open");
        button.setAttribute("aria-expanded", expanded ? "true" : "false");
        button.setAttribute("aria-label", expanded ? "Cerrar menu" : "Abrir menu");
      });

      const header = button.closest(".mcc-2026-header");
      header?.querySelectorAll(".mcc-2026-header__mobile-panel a").forEach((link) => {
        link.addEventListener("click", () => {
          header.classList.remove("is-open");
          button.setAttribute("aria-expanded", "false");
          button.setAttribute("aria-label", "Abrir menu");
        });
      });
    });

    document.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return;
      document.querySelectorAll(".mcc-2026-header.is-open").forEach((header) => {
        header.classList.remove("is-open");
        const button = header.querySelector("[data-mcc-menu-toggle]");
        button?.setAttribute("aria-expanded", "false");
        button?.setAttribute("aria-label", "Abrir menu");
      });
    });

    const revealSelectors = [
      ".mcc-2026-hero__kicker",
      ".mcc-2026-hero__title",
      ".mcc-2026-hero__lead",
      ".mcc-2026-hero__ctas",
      ".mcc-2026-shave__visual",
      ".mcc-2026-duo__product",
      ".mcc-2026-machine__wordmark",
      ".mcc-2026-machine__product",
      ".mcc-2026-pdp-machine__visual",
      ".mcc-2026-pdp-product-card",
      ".mcc-2026-bestsellers__title",
      ".mcc-2026-bestsellers__item",
      ".mcc-2026-values__heading",
      ".mcc-2026-values__card",
      ".mcc-2026-editorial-card",
      ".mcc-2026-ugc-card",
      ".mcc-2026-faq__item",
      ".mcc-2026-distributor__proof > div",
      ".mcc-2026-distributor__field",
      ".mcc-2026-distributor__consent",
      ".mcc-2026-distributor__submit",
      ".mcc-2026-footer__brand",
      ".mcc-2026-footer__links",
      ".mcc-2026-footer__newsletter",
      ".mcc-2026-footer__social"
    ];

    document.querySelectorAll(revealSelectors.join(",")).forEach((target) => {
      target.classList.add("mcc-2026-reveal");
      if (target.matches("img, picture, .mcc-2026-shave__visual, .mcc-2026-pdp-machine__visual")) {
        target.classList.add("mcc-2026-reveal--scale");
      }
    });

    document.querySelectorAll(".mcc-2026").forEach((section) => {
      const sectionTargets = Array.from(section.querySelectorAll(".mcc-2026-reveal")).filter(
        (target) => target.closest(".mcc-2026") === section
      );
      sectionTargets.forEach((target, index) => {
        target.style.setProperty("--mcc-reveal-delay", `${Math.min(index, 6) * 70}ms`);
      });
    });

    document.querySelectorAll(".mcc-2026-store-showcase__nav").forEach((nav) => {
      nav.querySelectorAll(".mcc-2026-store-showcase__nav-item").forEach((target, index) => {
        target.style.setProperty("--mcc-reveal-delay", `${index * 130}ms`);
      });
    });

    const initializeStoreInteractions = (root = document) => {
      root.querySelectorAll("[data-mcc-store-nav]").forEach((link) => {
        if (link.dataset.mccStoreNavReady === "true") return;
        link.dataset.mccStoreNavReady = "true";
        link.addEventListener(
          "click",
          (event) => {
            if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            const target = document.querySelector(link.hash);
            if (!target) return;
            event.preventDefault();
            event.stopPropagation();
            if (target instanceof HTMLDetailsElement) target.open = true;
            target.scrollIntoView({
              behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
              block: "start"
            });
          },
          true
        );
      });

      root.querySelectorAll("[data-mcc-hero-product-link]").forEach((link) => {
        if (link.dataset.mccHeroLinkReady === "true") return;
        link.dataset.mccHeroLinkReady = "true";
        link.addEventListener(
          "click",
          (event) => {
            if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            event.stopPropagation();
            window.location.assign(link.href);
          },
          true
        );
      });
    };

    const parseHeroNumber = (value) => {
      const parsed = Number.parseFloat(value);
      return Number.isFinite(parsed) ? parsed : null;
    };

    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

    const setHeroStyleProperty = (element, property, value) => {
      if (element.style.getPropertyValue(property) === value) return;
      element.style.setProperty(property, value);
    };

    const applyHeroProductAutoLayout = (heroSection) => {
      if (!heroSection) return;
      if (window.matchMedia("(max-width: 749px)").matches && heroSection.classList.contains("mcc-2026-hero--hide-products-mobile")) return;

      const productsRoot = heroSection.querySelector(".mcc-2026-hero__products--auto");
      if (!productsRoot) return;

      const isMobile = window.matchMedia("(max-width: 749px)").matches;
      const allCards = Array.from(productsRoot.querySelectorAll("[data-mcc-hero-product-link]"));
      const cards = allCards.filter((card) => {
        if (window.getComputedStyle(card).display === "none") return false;
        if (window.getComputedStyle(card).visibility === "hidden") return false;
        if (isMobile && card.classList.contains("mcc-2026-hero__product--hidden-mobile")) return false;
        return true;
      });

      const computedProductsStyle = window.getComputedStyle(productsRoot);
      const spreadProperty = cards.length <= 3 ? "--mcc-hero-desktop-spread-few" : "--mcc-hero-desktop-spread-many";
      const desktopSpread = clamp(
        parseHeroNumber(computedProductsStyle.getPropertyValue(spreadProperty)) || (cards.length <= 3 ? 34 : 52),
        cards.length <= 3 ? 20 : 30,
        cards.length <= 3 ? 70 : 90
      );
      const desktopColumns = Math.min(3, Math.max(1, cards.length));
      const desktopColumnSpread = cards.length <= 2 ? desktopSpread * 0.75 : desktopSpread;
      const desktopStart = 50 - desktopColumnSpread / 2;
      const desktopSlots = Array.from({ length: desktopColumns }, (_, slotIndex) => {
        if (desktopColumns === 1) return 50;
        return desktopStart + (desktopColumnSpread * slotIndex) / (desktopColumns - 1);
      });

      const config = isMobile
        ? {
            columns: 2,
            baseBottom: 24,
            rowGap: 86,
            xSlots: [34, 66]
          }
        : {
            columns: desktopColumns,
            baseBottom: 44,
            rowGap: 110,
            xSlots: desktopSlots
          };

      cards.forEach((card, index) => {
        const row = Math.floor(index / config.columns);
        const col = index % config.columns;
        const xSlot = config.xSlots[Math.min(col, config.xSlots.length - 1)];

        const baseWidthVar = isMobile
          ? parseHeroNumber(window.getComputedStyle(card).getPropertyValue("--mcc-product-width-mobile"))
          : parseHeroNumber(window.getComputedStyle(card).getPropertyValue("--mcc-product-width-desktop"));
        const baseWidth = Number.isFinite(baseWidthVar) ? baseWidthVar : isMobile ? 72 : 120;
        const limitWidth = isMobile ? 132 : 168;
        const minWidth = isMobile ? 52 : 90;
        const width = clamp(baseWidth, minWidth, limitWidth);

        setHeroStyleProperty(card, "--mcc-product-x-indexed", `${xSlot}%`);
        setHeroStyleProperty(card, "--mcc-product-y-indexed", `${config.baseBottom + row * config.rowGap}px`);
        setHeroStyleProperty(card, "--mcc-product-width-indexed", `${width}px`);
      });
    };

    const initializeHeroProductLayout = (root = document) => {
      const sections = Array.from(root.querySelectorAll(".mcc-2026-hero--layered"));
      sections.forEach((heroSection) => {
        if (heroSection.dataset.mccHeroLayoutReady !== "true") {
          heroSection.dataset.mccHeroLayoutReady = "true";
          const productsRoot = heroSection.querySelector(".mcc-2026-hero__products--auto");
          if (productsRoot) {
            let layoutFrame = 0;
            const scheduleLayout = () => {
              if (layoutFrame) return;
              layoutFrame = window.requestAnimationFrame(() => {
                layoutFrame = 0;
                applyHeroProductAutoLayout(heroSection);
              });
            };
            const observer = new MutationObserver(scheduleLayout);
            observer.observe(productsRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ["class", "style"] });
          }
        }
        applyHeroProductAutoLayout(heroSection);
      });
    };

    const initializeReviewAnchors = (root = document) => {
      root.querySelectorAll('.mcc-2026-pdp-main__rating-row[href="#mcc-product-reviews"]').forEach((link) => {
        if (link.dataset.mccReviewAnchorReady === "true") return;
        link.dataset.mccReviewAnchorReady = "true";
        link.addEventListener("click", (event) => {
          const target = document.querySelector("#mcc-product-reviews");
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({
            behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
            block: "start"
          });
          window.history.replaceState(null, "", "#mcc-product-reviews");
        });
      });
    };

    const initializeProductCardGalleries = (root = document) => {
      if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;

      root.querySelectorAll("[data-mcc-card-gallery]").forEach((card) => {
        if (card.dataset.mccCardGalleryReady === "true") return;

        const sources = (card.dataset.mccCardGallery || "")
          .split("||")
          .map((source) => source.trim())
          .filter(Boolean);
        const alternateImage = card.querySelector(".mcc-2026-card__image--hover");

        if (!alternateImage || sources.length === 0) return;

        card.dataset.mccCardGalleryReady = "true";
        let galleryIndex = 0;
        let rotationTimer = 0;

        const preload = () => {
          sources.forEach((source) => {
            const image = new Image();
            image.src = source;
          });
        };

        const showImage = (index) => {
          alternateImage.removeAttribute("srcset");
          alternateImage.src = sources[index];
        };

        const stop = () => {
          window.clearInterval(rotationTimer);
          rotationTimer = 0;
          card.classList.remove("is-gallery-active");
        };

        const start = () => {
          if (rotationTimer) return;
          preload();
          galleryIndex = 0;
          showImage(galleryIndex);
          card.classList.add("is-gallery-active");
          rotationTimer = window.setInterval(() => {
            galleryIndex = (galleryIndex + 1) % sources.length;
            showImage(galleryIndex);
          }, 900);
        };

        card.addEventListener("pointerenter", start);
        card.addEventListener("pointerleave", stop);
        card.addEventListener("focusin", start);
        card.addEventListener("focusout", (event) => {
          if (!card.contains(event.relatedTarget)) stop();
        });
      });
    };

    const initializeProductCardLinks = (root = document) => {
      root.querySelectorAll("[data-mcc-card-url]").forEach((card) => {
        if (card.dataset.mccCardLinkReady === "true") return;

        const cardUrl = card.dataset.mccCardUrl;
        if (!cardUrl) return;

        card.dataset.mccCardLinkReady = "true";
        card.tabIndex = 0;
        card.setAttribute("role", "link");
        card.addEventListener("click", (event) => {
          if (event.defaultPrevented) return;
          if (event.target.closest("a, button, input, select, textarea, label, form")) return;
          window.location.assign(cardUrl);
        });
        card.addEventListener("keydown", (event) => {
          if (event.key !== "Enter" && event.key !== " ") return;
          if (event.target.closest("a, button, input, select, textarea, label, form")) return;
          event.preventDefault();
          window.location.assign(cardUrl);
        });
      });
    };

    initializeStoreInteractions();
    initializeReviewAnchors();
    initializeProductCardGalleries();
    initializeProductCardLinks();
    initializeHeroProductLayout();
    let heroResizeFrame = 0;
    window.addEventListener(
      "resize",
      () => {
        if (heroResizeFrame) return;
        heroResizeFrame = window.requestAnimationFrame(() => {
          heroResizeFrame = 0;
          initializeHeroProductLayout();
        });
      },
      { passive: true }
    );

    document.querySelectorAll(".mcc-2026-distributor").forEach((section) => {
      const sequenceGroups = [
        [".mcc-2026-distributor__proof > div", 180],
        [".mcc-2026-distributor__benefit", 180],
        [".mcc-2026-distributor__step", 180],
        [".mcc-2026-distributor__form .mcc-2026-reveal", 90]
      ];

      sequenceGroups.forEach(([selector, delay]) => {
        section.querySelectorAll(selector).forEach((target, index) => {
          target.style.setProperty("--mcc-reveal-delay", `${index * delay}ms`);
          target.style.setProperty("--mcc-distributor-sequence", index);
        });
      });
    });

    const revealTargets = document.querySelectorAll(".mcc-2026-reveal");
    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const repeatsInStore = Boolean(entry.target.closest(".mcc-2026-store-showcase, [data-mcc-repeat-reveal]"));
            if (entry.isIntersecting) {
              entry.target.classList.add("is-visible");
              if (!repeatsInStore) observer.unobserve(entry.target);
            } else if (repeatsInStore) {
              entry.target.classList.remove("is-visible");
            }
          });
        },
        { threshold: 0.16, rootMargin: "0px 0px -8% 0px" }
      );
      revealTargets.forEach((el) => observer.observe(el));
    } else {
      revealTargets.forEach((el) => el.classList.add("is-visible"));
    }

    const revealVisibleTargets = () => {
      revealTargets.forEach((target) => {
        const rect = target.getBoundingClientRect();
        const isNearViewport =
          rect.top < window.innerHeight * 1.08 && rect.bottom > -window.innerHeight * 0.08;
        const repeatsInStore = Boolean(target.closest(".mcc-2026-store-showcase, [data-mcc-repeat-reveal]"));

        if (isNearViewport) {
          target.classList.add("is-visible");
        } else if (repeatsInStore) {
          target.classList.remove("is-visible");
        }
      });
    };

    let revealFrame = 0;
    const queueVisibleReveal = () => {
      if (revealFrame) return;
      revealFrame = window.requestAnimationFrame(() => {
        revealFrame = 0;
        revealVisibleTargets();
      });
    };

    window.requestAnimationFrame(revealVisibleTargets);
    window.setTimeout(revealVisibleTargets, 260);
    if (!("IntersectionObserver" in window)) {
      window.addEventListener("scroll", queueVisibleReveal, { passive: true });
      window.addEventListener("resize", queueVisibleReveal, { passive: true });
    }
    window.addEventListener("pageshow", revealVisibleTargets);

    document.addEventListener("shopify:section:load", (event) => {
      initializeStoreInteractions(event.target);
      initializeReviewAnchors(event.target);
      initializeProductCardGalleries(event.target);
      event.target.querySelectorAll(".mcc-2026-reveal").forEach((target) => target.classList.add("is-visible"));
      initializeHeroProductLayout(event.target);
    });

    if (window.matchMedia("(max-width: 749px)").matches && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      document.querySelectorAll("[data-mcc-snap-rail]").forEach((rail) => {
        const items = Array.from(rail.children);
        if (items.length < 2) return;

        const interval = Math.max(3000, parseInt(rail.dataset.mccSnapInterval || "5000", 10));
        let timer;
        let resumeTimer;

        const advance = () => {
          const gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap || "0");
          const step = items[0].getBoundingClientRect().width + gap;
          const atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - step * 0.65;
          rail.scrollTo({ left: atEnd ? 0 : rail.scrollLeft + step, behavior: "smooth" });
        };

        const start = () => {
          window.clearInterval(timer);
          timer = window.setInterval(advance, interval);
        };

        const pause = () => {
          window.clearInterval(timer);
          window.clearTimeout(resumeTimer);
        };

        const resume = () => {
          pause();
          resumeTimer = window.setTimeout(start, 1200);
        };

        rail.addEventListener("pointerenter", pause);
        rail.addEventListener("pointerleave", resume);
        rail.addEventListener("touchstart", pause, { passive: true });
        rail.addEventListener("touchend", resume, { passive: true });
        rail.addEventListener("focusin", pause);
        rail.addEventListener("focusout", resume);
        start();
      });
    }

    const initContinuousRails = (scope = document) => {
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

      scope.querySelectorAll("[data-mcc-continuous-rail]").forEach((rail) => {
        if (rail.dataset.mccContinuousReady === "true") return;

        const originalItems = Array.from(rail.children);
        if (originalItems.length < 2) return;

        rail.dataset.mccContinuousReady = "true";
        for (let copyIndex = 0; copyIndex < 3; copyIndex += 1) {
          originalItems.forEach((item) => {
            const clone = item.cloneNode(true);
            clone.setAttribute("aria-hidden", "true");
            clone.removeAttribute("id");
            clone.removeAttribute("data-shopify-editor-block");
            clone.classList.add("is-visible");
            clone.querySelectorAll("[id]").forEach((node) => node.removeAttribute("id"));
            clone.querySelectorAll("[data-shopify-editor-block]").forEach((node) => {
              node.removeAttribute("data-shopify-editor-block");
            });
            rail.appendChild(clone);
          });
        }

        const firstClone = rail.children[originalItems.length];
        const speed = Math.max(2, Number(rail.dataset.mccContinuousSpeed || 24));
        let loopWidth = 0;
        let offset = 0;
        let hasInitialPosition = false;
        let lastTime = 0;
        let interactionPaused = false;
        let isNearViewport = false;
        let frame = 0;

        const rebuildAnimation = () => {
          loopWidth = firstClone.offsetLeft - originalItems[0].offsetLeft;
          if (loopWidth <= 0) return;
          if (!hasInitialPosition) {
            // Start on the middle copy so the rail is populated on first paint.
            offset = loopWidth;
            hasInitialPosition = true;
          } else {
            while (offset < loopWidth) offset += loopWidth;
            while (offset >= loopWidth * 2) offset -= loopWidth;
          }
          rail.style.transform = `translate3d(${-offset}px, 0, 0)`;
        };

        const tick = (time) => {
          frame = 0;
          if (interactionPaused || !isNearViewport || document.hidden) return;
          if (!lastTime) lastTime = time;
          const elapsed = Math.min(80, time - lastTime);
          lastTime = time;

          if (loopWidth > 0) {
            offset += (speed * elapsed) / 1000;
            if (offset >= loopWidth * 2) offset -= loopWidth;
            rail.style.transform = `translate3d(${-offset}px, 0, 0)`;
          }

          frame = window.requestAnimationFrame(tick);
        };

        const syncAnimation = () => {
          const shouldRun = !interactionPaused && isNearViewport && !document.hidden;
          if (shouldRun && !frame) {
            lastTime = 0;
            frame = window.requestAnimationFrame(tick);
          } else if (!shouldRun && frame) {
            window.cancelAnimationFrame(frame);
            frame = 0;
          }
        };

        const pause = () => {
          interactionPaused = true;
          syncAnimation();
        };
        const play = () => {
          interactionPaused = false;
          syncAnimation();
        };

        rail.addEventListener("pointerenter", pause);
        rail.addEventListener("pointerleave", play);
        rail.addEventListener("focusin", pause);
        rail.addEventListener("focusout", play);

        const resizeObserver = new ResizeObserver(rebuildAnimation);
        resizeObserver.observe(rail);
        const visibilityObserver = new IntersectionObserver(
          (entries) => {
            isNearViewport = Boolean(entries[0]?.isIntersecting);
            if (isNearViewport) rebuildAnimation();
            syncAnimation();
          },
          { rootMargin: "240px 0px" }
        );
        visibilityObserver.observe(rail);
        document.addEventListener("visibilitychange", syncAnimation);
        window.requestAnimationFrame(rebuildAnimation);
      });
    };

    initContinuousRails();
    document.addEventListener("shopify:section:load", (event) => {
      initContinuousRails(event.target);
    });

    document.querySelectorAll(".mcc-2026-pdp-main").forEach((root) => {
      const sticky = root.querySelector(".mcc-2026-pdp-sticky");
      const primaryButton = root.querySelector(".mcc-2026-pdp-form__add");
      if (!sticky || !primaryButton || sticky.dataset.mccStickyReady === "true") return;

      document.querySelectorAll("body > .mcc-2026-pdp-sticky").forEach((existingSticky) => {
        if (existingSticky !== sticky) existingSticky.remove();
      });

      sticky.dataset.mccStickyReady = "true";
      document.body.appendChild(sticky);

      const setStickyVisibility = (entry) => {
        const hasPassedPrimaryAction = entry.boundingClientRect.bottom <= 0;
        sticky.classList.toggle("is-visible", !entry.isIntersecting && hasPassedPrimaryAction);
      };

      if ("IntersectionObserver" in window) {
        const stickyObserver = new IntersectionObserver(
          (entries) => entries[0] && setStickyVisibility(entries[0]),
          { threshold: 0 }
        );
        stickyObserver.observe(primaryButton);
      } else {
        const updateSticky = () => {
          const rect = primaryButton.getBoundingClientRect();
          sticky.classList.toggle("is-visible", rect.bottom <= 0);
        };
        window.addEventListener("scroll", updateSticky, { passive: true });
        updateSticky();
      }
    });

    document.querySelectorAll(".mcc-2026-ajax-atc").forEach((form) => {
      form.addEventListener("submit", async (event) => {
        if (event.submitter?.name === "checkout") return;
        event.preventDefault();
        const submit = event.submitter || form.querySelector('[type="submit"]');
        const originalMarkup = submit?.innerHTML;
        if (submit) {
          submit.disabled = true;
          submit.textContent = submit.dataset.loadingText || "Agregando...";
        }

        const formData = new FormData(form);
      const selectedExtra = form.querySelector('[data-mcc-extra]:checked');
      for (const key of [...formData.keys()]) if (key.startsWith('mcc_offer_')) formData.delete(key);
      if (selectedExtra && !selectedExtra.disabled) {
        const primaryFields = [...formData.entries()];
        for (const [key] of primaryFields) formData.delete(key);
        for (const [key, value] of primaryFields) {
          if (key === 'id' || key === 'quantity' || key === 'selling_plan') formData.append(`items[0][${key}]`, value);
          else if (key.startsWith('properties[')) formData.append(`items[0][properties]${key.slice(10)}`, value);
          else formData.append(key, value);
        }
        if (!formData.has('items[0][quantity]')) formData.append('items[0][quantity]', '1');
        formData.append('items[1][id]', selectedExtra.value);
        formData.append('items[1][quantity]', selectedExtra.dataset.quantity || '1');
      }

        const sectionIds = [];
        document.querySelectorAll("cart-items-component").forEach((item) => {
          if (item.dataset?.sectionId) sectionIds.push(item.dataset.sectionId);
        });
        if (sectionIds.length) formData.append("sections", sectionIds.join(","));

        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "X-Requested-With": "XMLHttpRequest"
            },
            body: formData
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || "No se pudo agregar.");

          document.dispatchEvent(
            new CustomEvent("cart:update", {
              bubbles: true,
              detail: {
                resource: {},
                sourceId: form.id || "",
                data: {
                  source: "mycocos-2026",
                  itemCount: (parseInt(formData.get("items[0][quantity]") || formData.get("quantity") || "1", 10) || 1) + (selectedExtra && !selectedExtra.disabled ? Number(selectedExtra.dataset.quantity || 1) : 0),
                  productId: form.closest("[data-product-id]")?.getAttribute("data-product-id"),
                  sections: data.sections || {}
                }
              }
            })
          );

          const drawer = document.querySelector("cart-drawer-component");
          if (drawer && typeof drawer.open === "function") drawer.open();
        } catch (error) {
          console.error("MyCOCOS 2026 add-to-cart failed", error);
          window.alert(error.message || "No se pudo agregar al carrito. Intenta de nuevo.");
        } finally {
          if (submit) {
            submit.disabled = false;
            submit.innerHTML = originalMarkup;
          }
        }
      });
    });

    document.querySelectorAll("[data-mcc-product-thumb]").forEach((button) => {
      button.addEventListener("click", () => {
        const root = button.closest(".mcc-2026-product, .mcc-2026-pdp-main");
        const main = root?.querySelector("[data-mcc-product-main-image]");
        const image = button.querySelector("img");
        if (main && image) {
          main.removeAttribute("srcset");
          main.removeAttribute("sizes");
          main.src = image.dataset.fullSrc || image.src;
          main.alt = image.alt || main.alt;
          root.querySelectorAll("[data-mcc-product-thumb]").forEach((thumb) => thumb.classList.remove("is-active"));
          button.classList.add("is-active");
        }
      });
    });

    document.querySelectorAll(".mcc-2026-pdp-main__gallery").forEach((gallery) => {
      const media = gallery.querySelector(".mcc-2026-pdp-main__media");
      const thumbs = Array.from(gallery.querySelectorAll("[data-mcc-product-thumb]"));
      if (!media || thumbs.length < 2) return;
      let touchStartX = 0;

      media.addEventListener(
        "touchstart",
        (event) => {
          touchStartX = event.changedTouches[0]?.clientX || 0;
        },
        { passive: true }
      );

      media.addEventListener(
        "touchend",
        (event) => {
          const delta = (event.changedTouches[0]?.clientX || 0) - touchStartX;
          if (Math.abs(delta) < 45) return;
          const activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains("is-active")));
          const nextIndex = delta < 0 ? Math.min(thumbs.length - 1, activeIndex + 1) : Math.max(0, activeIndex - 1);
          thumbs[nextIndex]?.click();
          thumbs[nextIndex]?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
        },
        { passive: true }
      );
    });

    document.querySelectorAll("[data-mcc-bundle-add]").forEach((button) => {
      button.addEventListener("click", async () => {
        const bundle = button.closest(".mcc-2026-pdp-bundle");
        const payloadNode = bundle?.querySelector("[data-mcc-bundle-items]");
        if (!payloadNode) return;

        let items = [];
        try {
          items = JSON.parse(payloadNode.textContent || "[]");
        } catch (error) {
          console.error("MyCOCOS 2026 bundle payload is invalid", error);
          return;
        }
        if (!items.length) return;

        const originalText = button.textContent;
        button.disabled = true;
        button.textContent = button.dataset.loadingText || "Agregando...";

        const sectionIds = [];
        document.querySelectorAll("cart-items-component").forEach((item) => {
          if (item.dataset?.sectionId) sectionIds.push(item.dataset.sectionId);
        });

        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest"
            },
            body: JSON.stringify({ items, sections: sectionIds.join(",") })
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || "No se pudo agregar el pack.");

          document.dispatchEvent(
            new CustomEvent("cart:update", {
              bubbles: true,
              detail: {
                resource: {},
                sourceId: "mycocos-2026-bundle",
                data: {
                  source: "mycocos-2026",
                  itemCount: items.reduce((total, item) => total + (Number(item.quantity) || 1), 0),
                  sections: data.sections || {}
                }
              }
            })
          );

          const drawer = document.querySelector("cart-drawer-component");
          if (drawer && typeof drawer.open === "function") drawer.open();
        } catch (error) {
          console.error("MyCOCOS 2026 bundle add failed", error);
          window.alert(error.message || "No se pudo agregar el pack. Intenta de nuevo.");
        } finally {
          button.disabled = false;
          button.textContent = originalText;
        }
      });
    });

    document.querySelectorAll("[data-mcc-quantity-change]").forEach((button) => {
      button.addEventListener("click", () => {
        const stepper = button.closest(".mcc-2026-pdp-form__stepper");
        const input = stepper?.querySelector('input[name="quantity"]');
        if (!input) return;
        const change = parseInt(button.dataset.mccQuantityChange || "0", 10);
        const minimum = parseInt(input.min || "1", 10);
        input.value = String(Math.max(minimum, (parseInt(input.value || "1", 10) || 1) + change));
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });

    document.querySelectorAll("[data-mcc-variant-input]").forEach((input) => {
      input.addEventListener("change", () => {
        if (!input.checked) return;
        const root = input.closest(".mcc-2026-pdp-main");
        if (!root) return;

        const price = root.querySelector("[data-mcc-variant-price]");
        const compare = root.querySelector("[data-mcc-variant-compare]");
        const stickyPrice = root.querySelector(".mcc-2026-pdp-sticky__summary span");
        const mainImage = root.querySelector("[data-mcc-product-main-image]");
        const variantPrice = input.dataset.mccVariantPrice || "";
        const variantCompare = input.dataset.mccVariantCompare || "";
        const variantImage = input.dataset.mccVariantImage || "";

        if (price && variantPrice) price.textContent = variantPrice;
        if (stickyPrice && variantPrice) stickyPrice.textContent = variantPrice;
        if (compare) {
          compare.textContent = variantCompare;
          compare.hidden = !variantCompare;
        }
        if (mainImage && variantImage) {
          mainImage.removeAttribute("srcset");
          mainImage.removeAttribute("sizes");
          mainImage.src = variantImage;
          root.querySelectorAll("[data-mcc-product-thumb]").forEach((thumb) => thumb.classList.remove("is-active"));
        }
      });
    });

    document.querySelectorAll("[data-mcc-catalog]").forEach((catalog) => {
      const search = catalog.querySelector("[data-mcc-catalog-search]");
      const sort = catalog.querySelector("[data-mcc-catalog-sort]");
      const grid = catalog.querySelector("[data-mcc-catalog-grid]");
      const count = catalog.querySelector("[data-mcc-catalog-count]");
      const empty = catalog.querySelector("[data-mcc-catalog-empty]");
      const filters = Array.from(catalog.querySelectorAll("[data-mcc-catalog-filter]"));
      const cards = Array.from(catalog.querySelectorAll("[data-mcc-catalog-card]"));
      let activeFilter = "all";

      const normalize = (value) =>
        String(value || "")
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase()
          .trim();

      const categoryMatches = (haystack, category) => {
        if (category === "all") return true;
        if (category === "pack") return haystack.includes("pack") || haystack.includes("kit");
        if (category === "rasuradora") return /rasur|afeitar|shaver|trimmer/.test(haystack);
        if (category === "jabon") return haystack.includes("jabon");
        return haystack.includes(category);
      };

      const updateCatalog = () => {
        const term = normalize(search?.value);
        const sortMode = sort?.value || "featured";
        const ordered = [...cards].sort((a, b) => {
          if (sortMode === "title-asc") return a.dataset.title.localeCompare(b.dataset.title, "es");
          if (sortMode === "price-asc") return Number(a.dataset.price) - Number(b.dataset.price);
          if (sortMode === "price-desc") return Number(b.dataset.price) - Number(a.dataset.price);
          return Number(a.dataset.featured) - Number(b.dataset.featured);
        });

        let visible = 0;
        ordered.forEach((card) => {
          const haystack = normalize(card.dataset.search);
          const show = (!term || haystack.includes(term)) && categoryMatches(haystack, activeFilter);
          card.hidden = !show;
          if (show) visible += 1;
          grid?.appendChild(card);
        });

        if (count) count.textContent = `${visible} ${visible === 1 ? "producto" : "productos"}`;
        if (empty) empty.hidden = visible !== 0;
      };

      filters.forEach((button) => {
        button.addEventListener("click", () => {
          activeFilter = button.dataset.mccCatalogFilter || "all";
          filters.forEach((item) => {
            const selected = item === button;
            item.classList.toggle("is-active", selected);
            item.setAttribute("aria-pressed", selected ? "true" : "false");
          });
          updateCatalog();
        });
      });

      search?.addEventListener("input", updateCatalog);
      sort?.addEventListener("change", updateCatalog);
      updateCatalog();
    });

    const policy = document.querySelector(".mcc-2026-policy");
    if (policy) {
      const article = policy.querySelector(".mcc-2026-policy__body");
      const toc = policy.querySelector("[data-mcc-policy-toc]");
      const progress = policy.querySelector("[data-mcc-policy-progress]");
      const headings = Array.from(article?.querySelectorAll("h2, h3") || []);

      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `politica-${index + 1}`;
        if (heading.tagName !== "H2" || !toc) return;

        const item = document.createElement("li");
        const link = document.createElement("a");
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;
        item.appendChild(link);
        toc.appendChild(item);
      });

      if (!toc?.children.length) {
        policy.classList.add("mcc-2026-policy--without-toc");
      }

      if (headings.length && "IntersectionObserver" in window) {
        const tocLinks = Array.from(toc?.querySelectorAll("a") || []);
        const headingObserver = new IntersectionObserver(
          (entries) => {
            const current = entries.find((entry) => entry.isIntersecting);
            if (!current) return;
            tocLinks.forEach((link) => {
              link.classList.toggle("is-active", link.getAttribute("href") === `#${current.target.id}`);
            });
          },
          { rootMargin: "-18% 0px -72% 0px", threshold: 0 }
        );
        headings.forEach((heading) => headingObserver.observe(heading));
      }

      let policyProgressTicking = false;
      const updatePolicyProgress = () => {
        if (!progress) return;
        const rect = policy.getBoundingClientRect();
        const total = Math.max(1, policy.offsetHeight - window.innerHeight);
        const completed = Math.min(1, Math.max(0, -rect.top / total));
        progress.style.transform = `scaleX(${completed})`;
        policyProgressTicking = false;
      };

      window.addEventListener(
        "scroll",
        () => {
          if (policyProgressTicking) return;
          policyProgressTicking = true;
          window.requestAnimationFrame(updatePolicyProgress);
        },
        { passive: true }
      );
      updatePolicyProgress();
    }
  });
})();

(function () {
  const ready = (fn) => {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  };

  ready(() => {
    document.querySelectorAll("[data-mcc-loox-toggle]").forEach((button) => {
      const section = button.closest(".mcc-2026-product-reviews");
      const viewport = section?.querySelector("[data-mcc-loox-viewport]");
      if (!viewport) return;

      button.addEventListener("click", () => {
        const expanded = viewport.classList.toggle("is-expanded");
        button.setAttribute("aria-expanded", expanded ? "true" : "false");
        button.textContent = expanded ? "Mostrar menos reseñas" : "Ver todas las reseñas";
      });
    });
  });
})();

(function () {
  const ready = (fn) => {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  };

  ready(() => {
    const host = document.querySelector("#mcc-product-reviews #looxReviews");
    if (!host) return;
    const applyLooxViewport = () => {
      const frame = host.querySelector("#looxReviewsFrame");
      if (!frame) return;
      frame.setAttribute("scrolling", "yes");
      frame.style.height = "100%";
      frame.style.maxHeight = "100%";
      frame.style.overflow = "auto";
    };
    const observer = new MutationObserver(applyLooxViewport);
    observer.observe(host, { childList: true, subtree: true });
    applyLooxViewport();
  });
})();

(function () {
  const ready = (fn) => {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  };

  ready(() => {
    const host = document.querySelector("#looxReviews");
    if (!host) return;

    let scrollTimer;
    let isInteracting = false;

    const prepare = () => {
      const candidates = Array.from(
        host.querySelectorAll(".review, [class*='review-card'], [class*='review-item'], [class*='loox-review']")
      ).filter((item) => item.parentElement && item.children.length > 0);
      if (candidates.length < 2) return false;

      const parent = candidates[0].parentElement;
      if (!candidates.every((item) => item.parentElement === parent)) return false;
      parent.classList.add("mcc-loox-review-rail");

      if (parent.dataset.mccLooxAutoReady === "true") return true;
      parent.dataset.mccLooxAutoReady = "true";
      parent.addEventListener("mouseenter", () => { isInteracting = true; });
      parent.addEventListener("mouseleave", () => { isInteracting = false; });
      parent.addEventListener("touchstart", () => { isInteracting = true; }, { passive: true });
      parent.addEventListener("touchend", () => {
        window.setTimeout(() => { isInteracting = false; }, 900);
      }, { passive: true });

      scrollTimer = window.setInterval(() => {
        if (isInteracting) return;
        const firstCard = parent.querySelector(":scope > .review, :scope > [class*='review-card'], :scope > [class*='review-item'], :scope > [class*='loox-review']");
        if (!firstCard) return;
        const step = firstCard.getBoundingClientRect().width + 16;
        const atEnd = parent.scrollLeft + parent.clientWidth >= parent.scrollWidth - step;
        parent.scrollTo({ left: atEnd ? 0 : parent.scrollLeft + step, behavior: "smooth" });
      }, 5200);
      return true;
    };

    const observer = new MutationObserver(() => prepare());
    observer.observe(host, { childList: true, subtree: true });
    prepare();
  });
})();
